/* @flow */
/* eslint-disable babel/no-invalid-this */
import VideoFeed from "nexia_mobile/models/mixins/video_feed";
import type { CameraFeature } from "./types";

export default function Camera(feature: CameraFeature) {
  // mix in the methods from VideoFeed
  _.extend(this, VideoFeed);

  this.isConnected = () => {
    return this.get("connected");
  };

  return {
    connected: feature.connected,
    status: feature.connected ? "Connected" : "Disconnected",
    quality: feature.quality,
    aspectRatio: feature.aspect_ratio,
  };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/camera.js